export default {"src":"/_next/static/media/circle3.4bf75e56.svg","height":76,"width":76,"blurWidth":0,"blurHeight":0};